/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { Component } from 'react';
import { Grid, Row, Col, FormControl, ControlLabel, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Card from 'Admin/components/Card/Card.jsx';
import { commentListAction, commentChangeStatusAction, autoSelectStatusAction } from 'Admin/actions/comments';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Loading from 'react-loading';
import { languageListAction } from 'Admin/actions/language';
import { appConstants } from 'Admin/_constants/app.constants';

var count = 1;

class CommentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            languageList: [],
            commentList: [],
            isLoading: true,
            asc_desc: true,
            userRow: null,
            totalCount: 0,
            currentPage: 1,
            sizePerPage: 10,
            searchText: "",
            formData: {
                foodCategoryId: "",
                direction: 'desc',
                order: "createdAt",
                offset: 0,
                limit: 10,
                lang: 1
            },
            limitForm: {},
        }

        this.onSerailNum = this.onSerailNum.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.onUserCount = this.onUserCount.bind(this);
    }

    componentDidMount() {
        this.props.commentListAction(this.state.formData);
        let data = this.state.limitForm;
        data['limitStatus'] = true;
        this.props.languageListAction(data);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.isCommentList !== this.props.isCommentList) {

            this.setState({
                commentList: nextProps.CommentList.data.data,
                totalCount: nextProps.CommentList.data.count
            });
        }

        if (nextProps.isLanguageList !== this.props.isLanguageList) {

            this.setState({ languageList: nextProps.LanguageList.data });
        }


        if (this.state.isLoading == true) {
            this.setState({ isLoading: false });
        }
    }

    onSerailNum(cell, row, enumObject, rowIndex) {
        return count++;
    }

    onUserCount(cell, row, enumObject, rowIndex) {
        return (this.state.currentPage - 1) * (this.state.sizePerPage) + (rowIndex + 1);
    }

    editButton(cell, row, enumObject, rowIndex) {
        return (<p><Link to={{ pathname: `update-comment/` + row._id, state: { row } }} onClick={this.toggleEdit.bind(this, row)} ><i className="fa fa-pencil" aria-hidden="true"></i></Link>
            &nbsp;&nbsp; &nbsp;&nbsp;
            <a href="javascript:void(0)" onClick={this.statusChangedHandler.bind(this, row)}><i className={(row.status === "active") ? ('fa fa-check') : ('fa fa-remove')} aria-hidden="true"></i></a>
        </p>)
    }

    toggleEdit(event) {
        this.setState({
            userRow: event
        });
    }

    statusChangedHandler(event, elename) {
        let newstatus = {};
        if (event.status == 'active') {
            newstatus = 'inactive';
        } else {
            newstatus = 'active';
        }
        event['id'] = event._id;
        event['status'] = newstatus;
        this.props.commentChangeStatusAction(event);
    }

    _setTableOption() {
        if (this.state.isLoading) {
            return (
                <Loading type='bars' color='#000000' style={{ margin: '0px auto', width: "40px" }} />
            );
        } else {
            return "No data found!";
        }
    }

    navigateto() {
        window.location.href = "Admin/add-food";
        this.clicked = "";
    }


    handleLanguage(event) {
        let formData = this.state.formData
        formData['lang'] = event.target.value
        this.setState({ formData: formData });
    }

    handleText(cell, row, enumObject, rowIndex) {
        return row.text[this.state.formData.lang]
    }

    autoSelect(cell, row, enumObject, rowIndex) {
        // if(row.auto_select){
        //  return (<p><input type="checkbox" checked id={row._id}   onChange={this.autoSelectStatus.bind(this, row)} /></p>)
        // } else {
        //   return (<p><input type="checkbox"  id={row._id} onChange={this.autoSelectStatus.bind(this, row)}/></p>)
        // }

        return (<p><input type="checkbox" checked={row.auto_select} id={row._id} onChange={this.autoSelectStatus.bind(this, row)} /></p>)
    }

    autoSelectStatus(data) {
        this.props.autoSelectStatusAction(data);
    }

    onSearch(e) {
        e.preventDefault();
        let formData = this.state.formData;
        this.props.commentListAction(formData)
    }

    onPageChange(page, sizePerPage) {
        let data = {};
        if (this.state.searchText === "") {
            data['direction'] = this.state.formData.direction;
            data['order'] = this.state.formData.order;
            data['offset'] = (page === -1) ? this.state.formData.offset : page - 1;
            data['limit'] = sizePerPage;
        } else {
            data['direction'] = this.state.formData.direction;
            data['order'] = this.state.formData.order;
            data['offset'] = (page === -1) ? this.state.formData.offset : page - 1;
            data['limit'] = sizePerPage;
        }

        this.setState({ sizePerPage: sizePerPage })
        this.setState({ currentPage: page })
        this.props.commentListAction(data)

        if (this.state.sizePerPage !== sizePerPage || this.state.totalCount < page * sizePerPage) {
            eval('$(".ps").scrollTop(0)');
        }
    }

    onSearchChange(text) {
        if (text !== "") {
            if (text.length >= 1) {
                let data = {}
                data['direction'] = this.state.formData.direction;
                data['order'] = this.state.formData.order;
                data['offset'] = this.state.formData.offset;
                data['limit'] = this.state.formData.limit;
                data['search'] = text;
                data['lang'] = this.state.formData.lang;
                this.setState({ sizePerPage: 10 })
                this.setState({ currentPage: 1 })
                this.props.commentListAction(data);
            }
        } else {
            setTimeout(() => {
                this.componentDidMount();
            }, 100);
        }
        this.setState({ searchText: text });
    }

    sortHandle() {
        this.setState({ asc_desc: !this.state.asc_desc });
        let data = this.state.formData;
        data.direction = this.state.asc_desc ? "asc" : "desc"
        this.setState({ formData: data });
        this.props.commentListAction(data);
    }

    goBackFun(e) {
        this.props.history.replace(sessionStorage.getItem("prvUrl"))
    }

    render() {


        const selectRowProp = { mode: 'checkbox' };
        const options = {
            onSortChange: this.onSortChange,
            clearSearch: true,
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPage: this.state.sizePerPage,
            onPageChange: this.onPageChange,
            page: this.state.currentPage,
            // onSearchChange: this.onSearchChange,
            noDataText: this._setTableOption(),
        };

        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                content={
                                    <div className="fresh-datatables">
                                        <Row>
                                            <Col md={6}>
                                                <Button bsStyle="info" fill pullRight onClick={() => this.props.history.replace('add-comment')}>Add Comment</Button>
                                            </Col>
                                        </Row>&nbsp;

                                        <Row>

                                            <Col md={3}>
                                                <Col componentClass={ControlLabel}>
                                                    Language
                                                </Col>

                                                <FormControl componentClass="select" name="langname" value={this.state.formData.lang} onChange={e => { this.handleLanguage(e); }}>
                                                    <option value="">Select Language</option>
                                                    {this.state.languageList.map(function (item) {
                                                        return <option key={item.lanId} value={item.lanId}>{appConstants.ucFirst(item.name)}</option>
                                                    })}
                                                </FormControl>
                                            </Col>
                                        </Row>&nbsp;
                                        <div className="table-resposive educator-L">
                                            <div className='search-box-admin'>
                                                <div className='search'>
                                                    <input type="text" name="search" className="form-control" onChange={e => { this.onSearchChange(e.target.value.trimStart().replace(/\s+/g, " ")); }} value={this.state.searchText} placeholder="Search" />
                                                    <span className='input-group-btn'>
                                                        <Button onClick={(e) => { this.onSearchChange(e.target.value, "null") }}>Clear</Button>
                                                    </span>
                                                </div>
                                            </div>
                                            <BootstrapTable
                                                selectRow="{selectRowProp}"
                                                deleteRow={false}
                                                data={this.state.commentList}
                                                // search={true}
                                                multiColumnSearch={true}
                                                pagination={true}
                                                options={options}
                                                striped
                                                hover
                                                condensed
                                                scrollTop={'Bottom'}
                                                remote={true}
                                                fetchInfo={{ dataTotalSize: this.state.totalCount }}
                                            >
                                                <TableHeaderColumn hidden={true} tdAttr={{ 'data-attr': '_id' }} dataField='invitationId' isKey searchable={false}>Id</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '2%', textAlign: 'center' }} tdStyle={{ width: '2%', textAlign: 'center' }} tdAttr={{ 'data-attr': '#' }} dataField='' dataFormat={this.onUserCount}>#</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '20%', textAlign: 'center' }} tdStyle={{ width: '20%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'text' }} dataFormat={this.handleText.bind(this)}  >Comment
                                                    {
                                                        this.state.asc_desc ?
                                                            <i onClick={(e) => { this.sortHandle() }} style={{ cursor: 'pointer' }} class="fa fa-caret-up" aria-hidden="true"></i> :
                                                            <i onClick={(e) => { this.sortHandle() }} style={{ cursor: 'pointer' }} class="fa fa-caret-down" aria-hidden="true"></i>
                                                    }
                                                </TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '10%', textAlign: 'center' }} tdStyle={{ width: '10%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'type' }} dataField='type' dataFormat={appConstants.diabetic}>Type</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '5%', textAlign: 'center' }} tdStyle={{ width: '5%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'auto_select' }} dataFormat={this.autoSelect.bind(this)} >Auto Select</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '8%', textAlign: 'center' }} tdStyle={{ width: '8%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Status' }} dataField='status' dataFormat={appConstants.ucFirst}>Status</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '8%', textAlign: 'center' }} tdStyle={{ width: '8%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Action' }} dataFormat={this.editButton.bind(this)} >Action</TableHeaderColumn>
                                            </BootstrapTable>
                                        </div>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        CommentList: state.comment.CommentList,
        isCommentList: state.comment.isCommentList,
        isCommentListError: state.comment.isCommentListError,

        CommentChangeStatus: state.comment.CommentChangeStatus,
        isCommentChangeStatus: state.comment.isCommentChangeStatus,
        isCommentChangeStatusError: state.comment.isCommentChangeStatusError,

        CommentAutoSelectStatus: state.comment.CommentAutoSelectStatus,
        isCommentAutoSelectStatus: state.comment.isCommentAutoSelectStatus,
        isCommentAutoSelectStatusError: state.comment.isCommentAutoSelectStatusError,

        LanguageList: state.language.LanguageList,
        isLanguageList: state.language.isLanguageList,
        isLanguageListError: state.language.isLanguageListError,

    }
}
export default withRouter(connect(mapStateToProps, { commentListAction, commentChangeStatusAction, autoSelectStatusAction, languageListAction })(CommentList));
